import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface MenuState {
    isDashboardDrawerOpened: boolean,
    isComponentDrawerOpened: boolean
}

const initialState: MenuState = {
    isDashboardDrawerOpened: false,
    isComponentDrawerOpened: true
}

export const menuSlice = createSlice({
    name: "menu",
    initialState,
    reducers: {
        handlerComponentDrawer: (state, action: PayloadAction<{isComponentDrawerOpened: boolean}>) => {
            state.isComponentDrawerOpened = action.payload.isComponentDrawerOpened
        },
        handlerDrawerOpen: (state, action: PayloadAction<boolean>) => {
            state.isDashboardDrawerOpened = action.payload
        }
    }
})

export const {
    handlerComponentDrawer,
    handlerDrawerOpen
} = menuSlice.actions

export default menuSlice.reducer